import Panel1 from "../../assets/images/app-store-panel-1.png";
import Panel2 from "../../assets/images/app-store-panel-2.png";
import Panel3 from "../../assets/images/app-store-panel-3.png";
import IconDownload from "../../assets/images/app-store-download.svg";

import "./AppStoreAd.scss";
import ReactWOW from "react-wow";

const APP_DOWNLOAD_LINK = "https://apps.apple.com/us/app/luci-fun-personal-finance/id6739983865";

const AppStoreAd = () => {

     //
     return (
        <section id="app" className="app-store-ad">
            <div style={{display: "flex"}}>
                <hr/>
                <div className="app-store-panels-container">
                    <div className="app-store-panels">
                        <ReactWOW animation="fadeInLeft" delay="0.5s" >   
                            <div className="app-store-panel panel-mobile-text">
                                <div className="icon-download">
                                    <h2>Ready for a Fun Way to Master Your Money?</h2>
                                    <p>Download our gamified app and make learning personal finance an adventure!</p>
                                    <a target="_blank" href={APP_DOWNLOAD_LINK}>
                                        <img src={IconDownload}/>
                                    </a>
                                </div>
                            </div>
                        </ReactWOW>
                        <ReactWOW animation="fadeInRight" delay="0.5s">
                            <div className="app-store-panel">
                                <div className="icon-container">
                                    <img src={Panel1}/>
                                </div>
                            </div>
                            <div className="app-store-panel">
                                <div className="icon-container">
                                    <img src={Panel2}/>
                                </div>
                            </div>
                            <div className="app-store-panel">
                                <div className="icon-container">
                                    <img src={Panel3}/>
                                </div>
                            </div>
                        </ReactWOW>
                    </div>
                </div>
                <hr/>
            </div>
        </section>
     );
};


export default AppStoreAd;